import { Flex } from "@thenounproject/lingo-core";
import React from "react";
import { MarketingButton, TextButton } from "../buttons";
import { MarketingButtons } from "../MarketingButtons";

export default function CtaButtonComponent({ isMobile = false }: { isMobile: boolean }) {
  if (isMobile) {
    return (
      <Flex mb="40px">
        <MarketingButton href="/get-started/login" variant="outlineBlack" small>
          Login
        </MarketingButton>
      </Flex>
    );
  }

  return (
    <Flex gap="16px" alignItems="center">
      <TextButton href="/get-started/login">Login</TextButton>
      <MarketingButton href={MarketingButtons.getStarted.link}>
        {MarketingButtons.getStarted.text}
      </MarketingButton>
    </Flex>
  );
}
